import { APColumn, APFormFieldText, APIcon, APPalette, APRow, APSizedBox, APText, APTypography, getIt, JourneyStepApp, showAlertSnackBarConfirmation, showErrorDialog, showSnackbar } from 'ap-components';
import React, { useEffect, useState } from 'react'
import { EmpanelmentData } from '.';
import EmpanelmentService from '../../Services/EmpanelmentService';
import SharedPrefs from '../../Services/SharedPrefs';

export function generateDropOffLinkv2() {
    let url = new URL("https://partner.assetplus.in/signup/stepper");
    const token = getIt(SharedPrefs).getItem('poToken');
    if (!token) {
        throw new Error("Unauthorized Access");
    }

    return url.toString();
}

export default function VerifyDetails({ empanelmentData, updateEmpanelmentData, maskedEmail, maskedPhone, logId }: { empanelmentData: Partial<EmpanelmentData>, updateEmpanelmentData: (data: Partial<EmpanelmentData>) => void, maskedEmail: string, maskedPhone: string, logId: string }): JourneyStepApp {
    const [otp] = useState({
        emailOTP: '',
        phoneOTP: ''
    });
    const [emailKey, setemailKey] = useState(0);
    const [phoneKey, setPhoneKey] = useState(0);
    const [error, setError] = useState({
        emailError: empanelmentData.isEmailVerified === false ? "Invalid OTP.Please try again or Resend OTP" : undefined,
        phoneError: empanelmentData.isPhoneVerified === false ? "Invalid OTP.Please try again or Resend OTP" : undefined,
    })

    const [emailTimer, setEmailTimer] = useState(30);
    const [phoneTimer, setPhoneTimer] = useState(30);

    useEffect(() => {
        let interval: any;
        if (emailTimer > 0) {
            interval = setInterval(() => {
                setEmailTimer((t) => (t > 0 ? t - 1 : 0));
            }, 1000);
        }
        return () => clearInterval(interval);
    }, [emailTimer]);

    useEffect(() => {
        let interval: any;
        if (phoneTimer > 0) {
            interval = setInterval(() => {
                setPhoneTimer((t) => (t > 0 ? t - 1 : 0));
            }, 1000);
        }
        return () => clearInterval(interval);
    }, [phoneTimer]);

    async function resendEmailOTP() {
        try {
            await getIt(EmpanelmentService).resendOtp({ logId: logId, type: 'email' });
            showAlertSnackBarConfirmation({ content: "OTP Sent to Email successfully.", intent: "positive", emphasis: "intense" });
            setEmailTimer(30);
        } catch (err) {
            showAlertSnackBarConfirmation({ content: "Failed to Send OTP, try again.", intent: "negative", emphasis: "intense" });
        }
    };

    async function resendPhoneOTP() {
        try {
            await getIt(EmpanelmentService).resendOtp({ logId: logId, type: 'phone' });
            showAlertSnackBarConfirmation({ content: "OTP Sent to Mobile successfully.", intent: "positive", emphasis: "intense" });
            setPhoneTimer(30);
        } catch (err) {
            showAlertSnackBarConfirmation({ content: "Failed to Send OTP, try again.", intent: "negative", emphasis: "intense" });
        }
    };

    return ({
        title: "Basic Details",
        code: 'Basic Details',
        description: "Next: Personal Details",
        form: ((
            <APColumn mainAxisAlignment='center' crossAxisAlignment='stretch' mainAxisSize='max'>
                <APText style={APTypography.h1}>Account Verification</APText>
                <APSizedBox height='12px' />
                <APText style={APTypography['paragraph-medium']}>Ensure your account is secure by verifying your email and phone number below. </APText>
                <APSizedBox height='16px' />
                <APRow mainAxisAlignment='spaceBetween'>
                    <APRow mainAxisAlignment='start'>
                        <div style={{ borderRadius: '100%', backgroundColor: (error.phoneError && empanelmentData.isPhoneVerified === false ? APPalette['negative-100'] : APPalette['brand-100']), padding: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', }}>
                            <APIcon icon='phone' color={(error.phoneError && empanelmentData.isPhoneVerified === false) ? APPalette['negative-300'] : APPalette['brand-300'].replace('rgb', 'rgba').replace(')', `, ${empanelmentData.isPhoneVerified ? 0.5 : 1})`)} size={12} />
                        </div>
                        <APSizedBox width='8px' />
                        <APText style={{ ...APTypography.h4, flex: 'none', color: `${error.phoneError && empanelmentData.isPhoneVerified === false ? APPalette['negative-300'] : APPalette['grey-700']}`, opacity: `${empanelmentData.isPhoneVerified ? '0.5' : '1'}` }}>Phone Number Verification</APText>
                        <div style={{ flex: 1 }} />
                        {error.phoneError && empanelmentData.isPhoneVerified === false && <APIcon icon='negativeSubtle' color={APPalette['negative-300']} size={20} />}
                        {empanelmentData.isPhoneVerified === true && <APIcon icon='checkCircleSolid' color={APPalette['positive-300']} size={20} />}
                    </APRow>
                </APRow>
                <APSizedBox height='6px' />
                <APText style={{ ...APTypography['paragraph-xsmall'], color: `${APPalette['grey-600']}`, opacity: `${empanelmentData.isPhoneVerified ? '0.5' : '1'}` }}>{`(Enter the 6 digit OTP sent to +91 ${maskedPhone})`}</APText>
                <APSizedBox height='8px' />
                <APFormFieldText
                    maxLength={6}
                    style={{ width: '100%' }}
                    key={`phone-${phoneKey}`}
                    label='Phone OTP'
                    onChanged={(v: any) => {
                        otp.phoneOTP = v;
                    }}
                    validator={(v) => {
                        if (
                            empanelmentData.isPhoneVerified === false &&
                            (v.length === 0 || v.length !== 6)
                        ) {
                            return "Please enter the 6 digit Phone OTP";
                        }
                        if (error.phoneError !== undefined) setError(prev => ({ ...prev, phoneError: undefined }));
                    }}
                    error={
                        empanelmentData.isPhoneVerified === false ? error.phoneError : undefined
                    }
                    readOnly={empanelmentData.isPhoneVerified}
                    placeholder="Enter Phone OTP"
                    keyboardType="number"
                />
                <APSizedBox height='8px' />
                <APRow mainAxisSize="max" mainAxisAlignment="start" crossAxisAlignment="center">
                    <APText style={{ ...APTypography['subheading-sh2'], opacity: `${empanelmentData.isPhoneVerified ? '0.5' : '1'}` }}>
                        Don't see a code?
                    </APText>
                    <APSizedBox width='4px' />
                    <APText style={{ textDecoration: "underline", color: `${APPalette['brand-300']}`, opacity: `${empanelmentData.isPhoneVerified || phoneTimer > 0 ? '0.5' : '1'}` }} variant="paragraph-medium" onClick={empanelmentData.isPhoneVerified || phoneTimer > 0 ? undefined : async () => await resendPhoneOTP()}>
                        {`Resend Phone OTP${!empanelmentData.isPhoneVerified && phoneTimer > 0 ? ` in ${phoneTimer}s.` : "."}`}
                    </APText>
                </APRow>
                <div style={{ backgroundColor: APPalette["grey-200"], width: "100%", height: '2px', margin: '16px 6px 16px 2px' }}></div>
                <APRow mainAxisAlignment='start' mainAxisSize='max'>
                    <div style={{ borderRadius: '100%', backgroundColor: (error.emailError && empanelmentData.isEmailVerified === false ? APPalette['negative-100'] : APPalette['brand-100']), padding: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', }}>
                        <APIcon icon='mail' color={(error.emailError && empanelmentData.isEmailVerified === false) ? APPalette['negative-300'] : APPalette['brand-300'].replace('rgb', 'rgba').replace(')', `, ${empanelmentData.isEmailVerified ? 0.5 : 1})`)} size={12} />
                    </div>
                    <APSizedBox width='8px' />
                    <APText style={{ ...APTypography.h4, flex: 'none', color: `${error.emailError && empanelmentData.isEmailVerified === false ? APPalette['negative-300'] : APPalette['grey-700']}`, opacity: `${empanelmentData.isEmailVerified ? '0.5' : '1'}` }}>Email Verification</APText>
                    <div style={{ flex: 1 }} />
                    {error.emailError && empanelmentData.isEmailVerified === false && <APIcon icon='negativeSubtle' color={APPalette['negative-300']} size={20} />}
                    {empanelmentData.isEmailVerified === true && <APIcon icon='checkCircleSolid' color={APPalette['positive-300']} size={20} />}
                </APRow>
                <APSizedBox height='6px' />
                <APText style={{ ...APTypography['paragraph-xsmall'], color: `${APPalette['grey-600']}`, opacity: `${empanelmentData.isEmailVerified ? '0.5' : '1'}` }}>{`(Enter the 6 digit OTP sent to ${maskedEmail})`}</APText>
                <APSizedBox height='8px' />
                <APFormFieldText
                    maxLength={6}
                    style={{ width: '100%' }}
                    key={`email-${emailKey}`}
                    onChanged={(v: any) => {
                        otp.emailOTP = v;
                    }}
                    label='Email OTP'
                    validator={(v) => {
                        if (
                            empanelmentData.isEmailVerified === false &&
                            (v.length === 0 || v.length !== 6)
                        ) {
                            return "Please enter the 6 digit Email OTP";
                        }
                        if (error.emailError !== undefined) setError(prev => ({ ...prev, emailError: undefined }));
                    }}
                    error={empanelmentData.isEmailVerified === false ? error.emailError : undefined}
                    readOnly={empanelmentData.isEmailVerified}
                    placeholder="Enter Email OTP"
                    keyboardType="number"
                />
                <APSizedBox height='8px' />
                <APRow mainAxisSize="max" mainAxisAlignment="start" crossAxisAlignment="center">
                    <APText style={{ ...APTypography['subheading-sh2'], opacity: `${empanelmentData.isEmailVerified ? '0.5' : '1'}` }}>
                        Don't see a code?
                    </APText>
                    <APSizedBox width='4px' />
                    <APText style={{ textDecoration: "underline", color: `${APPalette['brand-300']}`, opacity: `${empanelmentData.isEmailVerified || emailTimer > 0 ? '0.5' : '1'}` }} variant="paragraph-medium" onClick={(empanelmentData.isEmailVerified || emailTimer > 0) ? undefined : async () => await resendEmailOTP()}>
                        {`Resend Email OTP${!empanelmentData.isEmailVerified && emailTimer > 0 ? ` in ${emailTimer}s.` : "."}`}
                    </APText>
                </APRow>
                <APSizedBox height='4px' />
                <APText style={APTypography['paragraph-xsmall']}>Can't find the email? Please check the spam folder</APText>
            </APColumn>
        )),
        onSubmit: async () => {
            try {
                const response = await getIt(EmpanelmentService).verifyOTPv2({ arn: empanelmentData.arn!, emailotp: otp.emailOTP, phoneotp: otp.phoneOTP, logId: logId, pan: empanelmentData.pan!, dob: empanelmentData.dob! });
                updateEmpanelmentData({
                    ...response.empanelmentData,
                });
                getIt(SharedPrefs).setItem('poToken', response.token);
                getIt(SharedPrefs).setItem("Empanelment-ARN", empanelmentData.arn!);
            } catch (err: any) {
                const metaData = err?.response?.data.metaData;
                if (!!metaData) {
                    if (!metaData.isEmailVerified && !metaData.isPhoneVerified) {
                        otp.emailOTP = '';
                        setemailKey(x => x + 1);
                        otp.phoneOTP = '';
                        setPhoneKey(x => x + 1);
                        setError({ phoneError: err?.response?.data.userMsg, emailError: err?.response?.data.userMsg })
                    }

                    if (metaData.isEmailVerified) {
                        otp.phoneOTP = '';
                        setPhoneKey(x => x + 1);
                        setError({ ...error, phoneError: err?.response?.data.userMsg });
                    }
                    if (metaData.isPhoneVerified) {
                        otp.emailOTP = '';
                        setemailKey(x => x + 1);
                        setError({ ...error, emailError: err?.response?.data.userMsg });
                    }
                    updateEmpanelmentData({
                        ...empanelmentData,
                        isPhoneVerified: metaData.isPhoneVerified,
                        isEmailVerified: metaData.isEmailVerified,
                    });
                    throw err;
                } else {
                    console.log("ERROR:", err);
                    throw err;
                }
            }
        }
    });
}

